import { render, staticRenderFns } from "./TagLabel.vue?vue&type=template&id=62566eaa&"
import script from "./TagLabel.vue?vue&type=script&lang=js&"
export * from "./TagLabel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports